// Status tag colors. Mirrors the orders table (`getStatusStyles` in
// list-quotations.component.ts) so the order-detail header and the side-by-side
// panel render the exact same tag as the orders list. Keep in sync with the table.
const STATUS_STYLES: Record<string, { bg: string; text: string; border: string }> = {
  all:                { bg: '#949494', text: '#FFFFFF', border: '' },
  sent_to_erp:        { bg: '#ADE9D1', text: '#006F43', border: '#77DBB3' },
  done:               { bg: '#ADE9D1', text: '#006F43', border: '#77DBB3' },
  sale:               { bg: '#ADE9D1', text: '#006F43', border: '#77DBB3' },
  pending_inventory:  { bg: '#FFF2D0', text: '#765700', border: '#FFEAB0' },
  cancel:             { bg: '#FDD7D0', text: '#821500', border: '#FBBCB0' },
  declined:           { bg: '#FDD7D0', text: '#821500', border: '#FBBCB0' },
  draft:              { bg: '#E2E2E2', text: '#1C2B36', border: '' },
  archived:           { bg: '#F0F0F0', text: '#6B6B6B', border: '#D9D9D9' },
  processing:         { bg: 'rgba(100,73,219,0.10)', text: '#6449DB', border: 'rgba(100,73,219,0.28)' },
  needs_review:       { bg: '#FDD7D0', text: '#821500', border: '#FBBCB0' },
};

const DEFAULT_STYLE = { bg: '#D5F2FF', text: '#004768', border: '#74D3FF' };

export function getQuotationStatusStyles(status: string): { [key: string]: string } {
  const s = STATUS_STYLES[status] ?? DEFAULT_STYLE;
  return {
    'background-color': s.bg,
    'color': s.text,
    'border': `1px solid ${s.border}`,
  };
}
